import "antd/lib/spin/style";
import _Spin from "antd/lib/spin";
import React from 'react';
import styles from './index.scss';

function PageLoading() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.pageLoading
  }, /*#__PURE__*/React.createElement(_Spin, {
    className: styles.spin
  }));
}

export default PageLoading;